var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrabberYoli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "28px",
    viewBox: "0 0 26 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / grabber") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-/-grabber",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1, 1.0893)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.48,
    y1: 17.25,
    x2: 23.52,
    y2: 17.25,
    id: "Line-10",
    stroke: "#d49830",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    transform: "translate(12, 17.25) scale(-1, 1) translate(-12, -17.25)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.48,
    y1: 12.75,
    x2: 23.52,
    y2: 12.75,
    id: "Line-10",
    stroke: "#d49830",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    transform: "translate(12, 12.75) scale(-1, 1) translate(-12, -12.75)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.48,
    y1: 8.25,
    x2: 23.52,
    y2: 8.25,
    id: "Line-10",
    stroke: "#d49830",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    transform: "translate(12, 8.25) scale(-1, 1) translate(-12, -8.25)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    stroke: "#d49830",
    fill: "#d49830",
    strokeLinejoin: "round",
    transform: "translate(12, 2.25) scale(-1, 1) translate(-12, -2.25)",
    points: "12 0 16.5 4.5 7.5 4.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    stroke: "#d49830",
    fill: "#d49830",
    strokeLinejoin: "round",
    transform: "translate(12, 23.25) scale(-1, -1) translate(-12, -23.25)",
    points: "12 21 16.5 25.5 7.5 25.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrabberYoli);
export default __webpack_public_path__ + "static/media/grabberYoli.c61042f8564ac8502a99eb8f0228028e.svg";
export { ForwardRef as ReactComponent };